module.exports = __webpack_public_path__ + "static/media/harman_splash.cf5c6efd.png";